import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import * as tools from '../../utilities/_tools';
import jsonField from '../../tokens/field.json';
import jsonUpload from '../../tokens/upload.json';
var thumbnailTemplate = "\n<li class=\"".concat(jsonUpload["class"]).concat(jsonUpload.file["class"], " ").concat(jsonUpload["class"]).concat(jsonUpload.file["class"], "{{=it.status}}\" data-value=\"{{=it.name}}\">\n  <span class=\"").concat(jsonUpload["class"]).concat(jsonUpload.file["class"]).concat(jsonUpload.file.name, "\">{{=it.name}}</span>\n  <span class=\"").concat(jsonUpload["class"]).concat(jsonUpload.file["class"]).concat(jsonUpload.file.icon, "\"></span>\n  <button type=\"button\" title=\"{{=it.deleteFile}} {{=it.name}}\" class=\"").concat(jsonUpload["class"]).concat(jsonUpload["delete"], "\"></button>\n  {{? it.status == '--is-invalid'}}<div class=\"").concat(jsonUpload["class"]).concat(jsonUpload.file["class"]).concat(jsonUpload.file.message, "\">{{=it.message}}</div>{{?}}\n</li>\n");
export var Upload = /*#__PURE__*/_createClass(
/**
 * Init upload system for forms
 * @param {Node} prmUpload HTML input[type="file"] form element
 * @param {Object} prmTranslation object to contains all keys for translation available keys : uploadInvalidMessage
 */
function Upload(prmUpload) {
  var _this = this;
  var prmTranslation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  _classCallCheck(this, Upload);
  this.upload = prmUpload;
  this.field = tools.getClosest(this.upload, ".".concat(jsonField["class"]));
  this.wrapper = tools.getClosest(this.upload, ".".concat(jsonUpload["class"]));
  this.hiddenValues = this.upload.nextElementSibling;
  this.sizeLimit = this.upload.dataset.size;
  this.allowedTypes = this.upload.accept;
  this.fileTable = [];
  this.miniatureList = [];
  this.translation = prmTranslation;
  this.upload.addEventListener('change', function () {
    _processUploadedFiles.call(_this);
  });
});

//Not in the constructor because of jest error
function _checkInitUploadFilesCache() {
  if (this.uploadFilesList === undefined) {
    this.uploadFilesList = new DataTransfer();
  }
}

/**
 * Verify if we can upload a file and process it with thumbnails generation
 */
function _processUploadedFiles() {
  var _this2 = this;
  tools.forEach(this.upload.files, function (file) {
    if (!_isSizeValid(file.size, _this2.sizeLimit)) {
      console.error('Un fichier uploadé est trop lourd');
      _this2.miniatureList.push(_htmlToElem(_generateThumbnail(file, jsonUpload.status.invalid, _this2.translation)));
      // return;
    } else if (!_isTypeValid(file.type, _this2.allowedTypes)) {
      console.error('Un fichier uploadé ne correspond pas au format attendu');
      _this2.miniatureList.push(_htmlToElem(_generateThumbnail(file, jsonUpload.status.invalid, _this2.translation)));
      // return;
    } else {
      _this2.fileTable.push(file.name);
      _this2.miniatureList.push(_htmlToElem(_generateThumbnail(file, jsonUpload.status.valid, _this2.translation)));
    }
    _checkInitUploadFilesCache.call(_this2);
    _this2.uploadFilesList.items.add(file);
  });
  if (this.fileTable.length === 0) {
    this.upload.value = '';
  }
  if (this.hiddenValues) {
    this.hiddenValues.value = this.fileTable.join(',');
  }
  this.miniatureListUl = this.field.querySelector('.js-field__miniatures');
  if (this.miniatureListUl) {
    this.wrapper.removeChild(this.miniatureListUl);
  }
  this.wrapper.insertAdjacentHTML('beforeend', "<ul class=\"".concat(jsonUpload["class"]).concat(jsonUpload.files, " js-field__miniatures\"></ul>"));
  this.miniatureListUl = this.field.querySelector('.js-field__miniatures');
  tools.forEach(this.miniatureList, function (miniature) {
    miniature = miniature.outerHTML;
    _this2.miniatureListUl.insertAdjacentHTML('beforeend', miniature);
  });
  _deleteMiniatures.call(this);
  this.upload.files = this.uploadFilesList.files;
  this.upload.dispatchEvent(new Event('blur', {
    'target': this.upload
  }));
}

/**
 * Generate thumbnail for a file selected for upload
 * @param {File} prmFile
 */
function _generateThumbnail(prmFile, status, prmTranslation) {
  var tplData = {
    'src': window.URL.createObjectURL(prmFile),
    'name': prmFile.name,
    'status': status,
    'message': prmTranslation && prmTranslation.uploadInvalidMessage ? prmTranslation.uploadInvalidMessage : 'Le fichier est invalide',
    'deleteFile': prmTranslation && prmTranslation.deleteFileMessage ? prmTranslation.deleteFileMessage : 'Supprimer le fichier joint'
  };
  return tools.template(thumbnailTemplate, tplData);
}

/**
 * Init event to delete all minitatures when files are uploaded
 */
function _deleteMiniatures() {
  var _this3 = this;
  var miniatures = this.field.querySelector('.js-field__miniatures');
  miniatures.delegateEvent('click', ".".concat(jsonUpload["class"]).concat(jsonUpload["delete"]), function (event) {
    _this3.miniature = tools.getClosest(event.target, ".".concat(jsonUpload["class"]).concat(jsonUpload.file["class"]));
    _this3.hiddenValues.value = _this3.hiddenValues.value.split(',').filter(function (file) {
      return file !== event.target.parentElement.dataset.value;
    }).join(',');
    miniatures.removeChild(_this3.miniature);
    if (_this3.hiddenValues.value === '') {
      _this3.upload.value = '';
    }
    _checkInitUploadFilesCache.call(_this3);
    for (var i = 0; i < _this3.uploadFilesList.items.length; i++) {
      if (_this3.uploadFilesList.items[i].getAsFile().name === event.target.parentElement.dataset.value) {
        _this3.uploadFilesList.items.remove(i);
        break;
      }
    }
    _this3.upload.files = _this3.uploadFilesList.files;
    _this3.miniatureList.splice(_this3.miniatureList.indexOf(_this3.miniature), 1);
  });
}

/**
 *
 * @param {Number} prmSize
 * @returns {Number} size in Kb
 */
function _convertToKb(prmSize) {
  return Math.round(prmSize / 1024);
}

/**
 *
 * @param {Number} prmFileSize
 * @param {Number} prmSizeLimit
 * @returns {Boolean} says if file's size is under size limit
 */
function _isSizeValid(prmFileSize, prmSizeLimit) {
  return _convertToKb(prmFileSize) <= prmSizeLimit;
}

/**
 *
 * @param {Number} prmFileType
 * @param {Number} prmAllowedTypes
 * @returns {Boolean} says if file's type is allowed
 */
function _isTypeValid(prmFileType, prmAllowedTypes) {
  return prmAllowedTypes.indexOf(prmFileType) >= 0;
}

/**
 *
 * @param {String} html
 * @returns {HTML Object}
 */
function _htmlToElem(html) {
  var temp = document.createElement('template');
  html = html.trim(); // Never return a space text node as a result
  temp.innerHTML = html;
  return temp.content.firstChild;
}